import styled from 'styled-components';
import { Link } from 'gatsby';

export const SliderWrapper = styled.div`
  overflow: hidden;
`;

export const SliderFullWidth = styled.div`
  padding: 80px 0 30px;

  @media (max-width: 768px) {
    padding: 30px 0 0;
  }

  &.img_full_width {
    padding-bottom: 25px;

    @media (max-width: 992px) {
      padding-bottom: 0px;
    }
  }
  .slick-track {
    display: flow-root !important;
  }
  .slick-slide {
    padding: 0 0.75rem !important;
    width: 372px;
    height: 321px;
    position: relative;
    overflow: visible;
    float: ${({ dir }) => (dir === 'rtl' ? 'left' : '')};

    & > div {
      overflow: hidden;
    }

    @media (max-width: 376px) {
      /* height: 230px; */
      padding: 0 5px !important;
    }
  }

  .slick-list {
    overflow: visible;
    margin: 10px;
    z-index: 9;
  }

  .slick-dots {
    padding-top: 40px;

    @media (max-width: 767.98px) {
      padding-top: 20px;
    }
  }

  .slick-prev {
    left: 50px;
    z-index: 10;
    top: 40%;
  }

  .slick-prev:before,
  .slick-next:before {
    border: solid #fff;
    border-width: 0 4px 4px 0;
    opacity: 1;
  }

  .slick-next {
    right: 50px;
    z-index: 10;
    top: 40%;
  }

  button:focus {
    outline: 5px auto -webkit-focus-ring-color !important;
  }
`;

export const Slide = styled.div`
  .bimg {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200px;
    height: 200px;
    visibility: hidden;
    z-index: -1;
    transform: scale(0.9) translate(-50%, -50%);
    transition: 0.2s linear;
  }

  .active {
    visibility: visible;
    z-index: 5;
    overflow: hidden;
    width: 713px;
    height: 491px;
    display: block;
    transform: scale(1) translate(-50%, -50%);
    transition: all 0.3s;

    @media (max-width: 675px) {
      width: 100%;
      height: 100%;
    }

    @media (max-width: 575.98px) {
      width: 370px;
      height: 270px;
    }

    span {
      @media (max-width: 675px) {
        height: 100%;
        width: 100%;
      }

      img {
        @media (max-width: 675px) {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }
    }
  }
`;

export const SlideA = styled.a`
  .bimg {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200px;
    height: 200px;
    visibility: hidden;
    z-index: -1;
    transform: scale(0.9) translate(-50%, -50%);
    transition: 0.3s;
  }

  .active {
    visibility: visible;
    z-index: 5;
    overflow: hidden;
    width: 713px;
    height: 491px;
    display: block;
    transform: scale(1) translate(-50%, -50%);
    transition: all 0.3s;

    @media (max-width: 675px) {
      width: 100%;
      height: 100%;
    }

    @media (max-width: 575.98px) {
      width: 370px;
      height: 270px;
    }

    span {
      @media (max-width: 675px) {
        height: 100%;
        width: 100%;
      }

      img {
        @media (max-width: 675px) {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }
    }
  }
`;

export const FourSliderImage = styled.div`
  padding: 80px 0 30px;
  overflow: hidden;

  .slick-slide {
    padding: 0 0.75rem !important;
    position: relative;
    width: 367px !important;
    height: 321px;
    overflow: visible;

    & > div {
      overflow: hidden;
    }
  }

  .slick-list {
    overflow: visible !important;
  }

  .gatsby-image-wrapper {
    height: 100%;
  }

  .slick-track {
    display: flex;
    justify-content: center;
  }
`;

export const FourTextImage = styled.div`
  margin: 1rem 0;
  overflow: hidden;

  .slick-slide {
    padding: 0 30px 0 0;
    position: relative;
    width: 367px !important;
    height: 321px;
    overflow: visible;
    & > div {
      overflow: hidden;
    }
  }

  .slick-list {
    overflow: visible !important;
  }

  .gatsby-image-wrapper {
    height: 282px;
  }

  .slick-track {
    display: flex;
    justify-content: center;
  }
`;

export const SuggestedSliderBlock = styled.div`
  overflow: hidden;
  &.no-slider {
    @media (min-width: 767px) {
      display: flex;
      flex-wrap: wrap;
    }

    .download-link-block {
      padding: 0 10px;
      position: relative;
      @media (max-width: 767px) {
        padding: 0 5px;
      }

      /* @media (min-width: 1200px) {
        max-width: 25%;
        flex: 0 0 25%;
      }

      @media (max-width: 1199px) {
        max-width: 33.3333%;
        flex: 0 0 33.3333%;
      }

      @media (max-width: 991px) {
        max-width: 50%;
        flex: 0 0 50%;
      }
      @media (max-width: 767px) {
        max-width: 100%;
        flex: 0 0 100%;
      } */

      .slider-caption {
        top: auto;
        left: 15px;
        right: 15px;

        &[dir='ltr'] {
          text-align: right;
        }

        &[dir='rtl'] {
          text-align: left;
        }
      }
    }
  }
  &.itineraries-slider {
    .slick-slide {
      img {
        width: auto;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);
        transition: 0.5s;
      }
      &:hover {
        img {
          transform: translate(-50%, 0) scale(1.2);
        }
      }
    }
  }

  .slick-dots {
    display: none !important;
    padding-top: 10px;

    @media (max-width: 991.98px) {
      display: block !important;
    }

    @media (max-width: 767.98px) {
      display: block !important;
    }
  }

  .slick-track {
    @media (min-width: 768px) {
      display: flex;
      flex-wrap: wrap;
    }
  }
  @media (max-width: 767.98px) {
    display: block !important;
  }

  .slick-slide {
    position: relative;
    overflow: visible;
    margin: 2rem 0;
    @media (min-width: 768px) {
      width: 50%;
    }
    @media (min-width: 992px) {
      width: 33.33%;
    }
    @media (min-width: 1225px) {
      width: 295px !important;
    }

    @media (max-width: 1199px) {
      padding: 0 5px !important;
    }

    & > div {
      overflow: hidden;
    }
  }

  .slick-list {
    overflow: visible !important;
  }

  .gatsby-image-wrapper {
    height: 282px;
  }

  .slick-track {
    display: flex;
  }

  @media (min-width: 768px) {
    .slick-arrow {
      display: none;
    }
  }

  &[dir='ltr'],
  &[dir='rtl'] {
    .slick-arrow {
      z-index: 30;

      &.slick-next {
        right: 5px;
        left: auto;
      }

      &.slick-prev {
        left: 5px;
        right: auto;
      }
    }
  }
`;

export const Slidercard = styled(Link)`
  position: relative;
  overflow: hidden;
  height: 282px;
  display: block;

  img {
    transition: 0.5s !important;
  }

  &:hover {
    img {
      transform: scale(1.2);
    }
  }
`;
export const SliderCardDisabled = styled.div`
  position: relative;
  overflow: hidden;
  height: 282px;
  display: block;

  img {
    transition: 0.5s !important;
  }

  &:hover {
    img {
      transform: scale(1.2);
    }
  }
`;

export const SliderImage = styled.div`
  position: relative;
  overflow: hidden;
  height: 282px;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
  }

  span {
    display: block !important;
    height: 100%;
  }

  img {
    width: 100%;
    transition: 0.5s;
    height: 100%;
    max-width: unset;
    object-fit: cover;
    @media (max-width: 991px) {
      width: 100%;
    }
  }
`;

export const SliderCardCaption = styled.div`
  position: absolute;
  color: #fff;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 1.5rem 1rem 1.5rem 1.5rem;

  p {
    color: #fff;
    text-transform: uppercase;
    margin-bottom: 10px;
    font-size: 12px;
    line-height: ${({ dir }) => (dir === 'rtl' ? '16px' : '')};
    letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '1.29px')};
  }

  h3 {
    margin-bottom: 0px;
    text-align: ${({ dir }) => (dir === 'rtl' ? 'right' : 'left')};
    font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCMedium,serif!important' : '')};
  }
`;

export const SliderOnclickImage = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200px;
  height: 200px;
  visibility: hidden;
  transition: 0.3s;
  z-index: -1;
  transform: translate(-50%, -50%);

  &.active {
    visibility: visible;
    z-index: 5;
    transition: 0.3s;
    overflow: hidden;
    width: 713px;
    height: 491px;
    display: block;
  }
`;

export const FourCarousel = styled.div`
  @media (min-width: 1200px) {
    margin-right: -15px;
    margin-left: -15px;
  }
  .slick-dots {
    padding-top: 10px;

    @media (max-width: 991.98px) {
      display: block !important;
      padding-top: 2rem;
    }

    @media (max-width: 768px) {
      display: block !important;
      padding-top: 0px;
    }
  }

  .slick-track {
    flex-wrap: wrap;
    @media (max-width: 768px) {
      flex-wrap: inherit;
    }
  }

  &[dir='ltr'] {
    .slick-next {
      @media (max-width: 1200px) {
        right: -20px;
      }

      @media (max-width: 1099px) {
        right: -35px;
      }
    }

    .slick-prev {
      @media (max-width: 1200px) {
        left: -20px;
      }

      @media (max-width: 1099px) {
        left: -35px;
      }
    }
  }

  &[dir='rtl'] {
    .slick-next {
      @media (min-width: 1201px) {
        right: -50px;
        left: auto;
      }

      @media (max-width: 1200px) {
        right: -20px;
        left: auto;
      }

      @media (max-width: 1099px) {
        right: -35px;
      }
    }

    .slick-prev {
      @media (min-width: 1201px) {
        left: -50px;
        right: auto;
      }

      @media (max-width: 1200px) {
        right: auto;
        left: -20px;
      }

      @media (max-width: 1099px) {
        left: -35px;
      }
    }
    p {
      letter-spacing: 0;
    }
  }

  .slick-slide {
    overflow: visible;
    position: relative;
    margin: 2rem 0;

    @media (min-width: 1200px) {
      padding: 0 15px;
    }

    @media (max-width: 1199px) {
      padding: 0 5px;
    }

    & > div {
      overflow: hidden;
    }
  }

  button:focus {
    outline: 5px auto -webkit-focus-ring-color !important;
  }

  img {
    height: 282px;
  }

  .slick-track {
    display: flex;
    justify-content: center;
  }
`;

export const SliderStaticImage = styled.img`
  object-fit: contain;
  height: 100%;
`;

export const SLiderGImage = styled.div`
  display: block;
  overflow: hidden;
  height: 100%;
  width: 100%;
  position: relative;
  cursor: pointer;

  .lazy-load-image-background {
    display: block !important;
    width: 100%;
    height: 100%;
  }
  img {
    max-width: unset;
    width: auto;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1.1);
  }
`;

export const CloseButton = styled.p`
  position: absolute;
  right: 10px;
  top: 10px;
  width: 23px;
  height: 23px;
  cursor: pointer;

  &:before {
    position: absolute;
    left: 15px;
    content: ' ';
    height: 23px;
    width: 2px;
    background-color: #fff;
    transform: rotate(45deg);
  }

  &:after {
    position: absolute;
    left: 15px;
    content: ' ';
    height: 23px;
    width: 2px;
    background-color: #fff;
    transform: rotate(-45deg);
  }
`;

export const WhatsHappingCarousel = styled.div`
  padding: 50px 0;
  background: #ebebeb;
  overflow: hidden;
  margin-top: 50px;

  div[class*='SectionHeadlinestyled__SectionHeadline-'] {
    @media (min-width: 575px) {
      margin: 0rem 0 40px;
    }
  }
  &[dir='rtl'] {
    .slick-prev {
      &:before {
        transform: rotate(-45deg) !important;
      }
    }
    .slick-next {
      left: -40px !important;
      &:before {
        transform: rotate(135deg) !important;
      }
    }
  }
`;

export const SliderEvents = styled(Link)`
  padding: 0px 15px;

  span {
    height: 200px;
  }

  img {
    width: 100%;
    height: 200px;
    object-fit: cover;
  }
`;

export const EventDescription = styled.div`
  padding: 0px 15px;

  h3 {
    margin: 0.75rem 0 0.3rem;
    font-size: 18px;
    text-transform: none;
    letter-spacing: normal;
  }

  span {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '1.82px')};
    line-height: 15px;
  }
`;
